export const createTeam = (data) => {
    return data.data
}
export const coachRegisterApiGet = (data) => {
    return data.data
}
export const getTeamListApiGet = (data) => {
    return data.data
}
export const forgotPasswordApiGet = (data) => {
    return data.data
}
export const getPlayerApiGet = (data) => {
    return data.data
}
export const getCoachApiGet = (data) => {
    return data.data
}
export const getTeamApiGet = (data) => {
    return data.data
}
export const playerCreateApiGet = (data) => {
    return data.data
}
export const playerStatusPut = (data)=>{
    return data.data
}



